$(document).ready(() => {

  $('.hero-header .tabs span').on('click', function () {
    if (!$(this).hasClass('active')) {
      $('.hero-header .tabs span.active').removeClass('active');
      $(this).addClass('active');

      if($(this).hasClass('news')) {
        $('.news-search').addClass('active');
        $('.experts-search').removeClass('active');
      } else if($(this).hasClass('experts')) {
        $('.experts-search').addClass('active');
        $('.news-search').removeClass('active');
      }
    }
  });

  $('#contributor-application-note').on('keyup', function () {
    $('#current-characters').text($(this).val().length);
  });
});